"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactCookies = _interopRequireDefault(require("react-cookies"));

var ST = _interopRequireWildcard(require("./styled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CONSULTANT_URL = 'dom.ru/consultant';

var Chat = /*#__PURE__*/function (_Component) {
  _inherits(Chat, _Component);

  var _super = _createSuper(Chat);

  function Chat() {
    var _this;

    _classCallCheck(this, Chat);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: false,
      closeButtonVisible: false
    });

    _defineProperty(_assertThisInitialized(_this), "expand", function () {
      return _this.setState({
        expanded: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "collapse", function () {
      return _this.setState({
        expanded: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openChat", function () {
      var open = _this.props.open;

      if (open && typeof open === 'function') {
        open();
      } else {
        _this.handleOpen();
      }

      _this.collapse();
    });

    _defineProperty(_assertThisInitialized(_this), "closeMessageListener", function (e) {
      var close = _this.props.close;
      var message = e.data || e.message;

      if (message === 'close') {
        if (close && typeof close === 'function') {
          close();
        } else {
          _this.handleClose();
        }

        _this.collapse();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setHeight", function () {
      if (navigator.userAgent.indexOf('iPad') !== -1) {
        var chatHeight = Math.min(window.innerWidth, window.innerHeight);

        _this.setState({
          style: {
            height: chatHeight,
            top: (window.innerHeight - chatHeight) / 2 + 'px'
          }
        });
      }
    });

    return _this;
  }

  _createClass(Chat, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          chatLink = _this$props.chatLink,
          _this$props$initiator = _this$props.initiator,
          initiator = _this$props$initiator === void 0 ? '' : _this$props$initiator;
      var citydomain = _reactCookies["default"].load('citydomain') || 'perm';
      var defaultLink = 'https://' + citydomain + '.' + CONSULTANT_URL;
      var initiatorParam = initiator ? "?initiator=".concat(initiator) : '';
      this.setState({
        link: (chatLink || defaultLink) + initiatorParam
      });
      window.addEventListener('message', this.closeMessageListener);
      window.addEventListener('resize', this.setHeight);
      this.setHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.closeMessageListener);
      window.removeEventListener('resize', this.setHeight);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen !== undefined) {
        this.setState({
          isOpen: !prevProps.isOpen
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          expanded = _this$state.expanded,
          style = _this$state.style,
          link = _this$state.link;
      var _this$props2 = this.props,
          isHideButton = _this$props2.isHideButton,
          isOpen = _this$props2.isOpen,
          onLoad = _this$props2.onLoad;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isHideButton !== true ? /*#__PURE__*/_react["default"].createElement(ST.ChatButton, {
        expanded: expanded,
        onMouseEnter: this.expand,
        onMouseLeave: this.collapse,
        onClick: this.openChat,
        "data-test": "chat-btn"
      }, /*#__PURE__*/_react["default"].createElement(ST.ChatButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(ST.ChatButtonItem, null, /*#__PURE__*/_react["default"].createElement(ST.QuestionIcon, {
        content: "\\e623"
      })), /*#__PURE__*/_react["default"].createElement(ST.ChatButtonLabel, {
        expanded: expanded
      }, "\u041E\u043D\u043B\u0430\u0439\u043D-\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u043D\u0442"))) : null, isOpen ? /*#__PURE__*/_react["default"].createElement(ST.ChatContainer, _extends({
        title: "chat",
        src: link
      }, style, {
        onLoad: onLoad,
        name: "chat",
        "data-test": "chat-container"
      })) : null);
    }
  }]);

  return Chat;
}(_react.Component);

var _default = Chat;
exports["default"] = _default;